import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppLayout from '@cloudscape-design/components/app-layout';
import ContentLayout from '@cloudscape-design/components/content-layout';
import Header from '@cloudscape-design/components/header';
import Container from '@cloudscape-design/components/container';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Box from '@cloudscape-design/components/box';
import Button from '@cloudscape-design/components/button';
import ColumnLayout from '@cloudscape-design/components/column-layout';
import Icon from '@cloudscape-design/components/icon';

const features = [
  {
    title: 'Business Metrics Recommender',
    description: 'Analyze pipelines and discover missing business metrics using AI-powered recommendations. Get prioritized suggestions with implementation guidance.',
    icon: '🔍',
    path: '/metrics-recommender',
    tags: ['AI-powered', 'P0/P1/P2 prioritization', 'Feedback loop'],
  },
  {
    title: 'Monitor Threshold Analysis',
    description: 'Evaluate existing monitor thresholds across your services. Identify misconfigured alarms, noisy alerts, and gaps in monitoring coverage.',
    icon: '📊',
    path: '/threshold-analysis',
    tags: ['Alarm tuning', 'Noise reduction', 'Coverage gaps'],
  },
];

const LandingPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <AppLayout
      navigationHide
      toolsHide
      contentType="default"
      content={
        <ContentLayout
          header={
            <Header
              variant="h1"
              description="Tools to improve operational excellence and observability across your services"
            >
              Metrics Insight AI
            </Header>
          }
        >
          <ColumnLayout columns={2}>
            {features.map(f => (
              <Container
                key={f.path}
                header={
                  <Header
                    variant="h2"
                    actions={
                      <Button variant="primary" onClick={() => navigate(f.path)}>
                        Open
                      </Button>
                    }
                  >
                    {f.icon} {f.title}
                  </Header>
                }
              >
                <SpaceBetween size="m">
                  <Box variant="p">{f.description}</Box>
                  <SpaceBetween size="xs" direction="horizontal">
                    {f.tags.map(t => (
                      <Box
                        key={t}
                        display="inline-block"
                        fontSize="body-s"
                        color="text-status-inactive"
                      >
                        • {t}
                      </Box>
                    ))}
                  </SpaceBetween>
                </SpaceBetween>
              </Container>
            ))}
          </ColumnLayout>
        </ContentLayout>
      }
    />
  );
};

export default LandingPage;
